/* global Fw, tinyMCE */

(function() {
    /* jshint validthis: true */
	"use strict";
    
    window.submittingForm = window.hasOwnProperty('submittingForm') ? window.submittingForm : false;
    
    const actionPath = '/action/ticketAction';
    
    var tools_form;
    var utils_recaptcha;

	function init() {
        //INIT STOP
        if (!document.querySelector(".support-tickets-zone")) return;
        
        tools_form = Fw.component.models().form;
		utils_recaptcha = Fw.component.models().utils.recaptcha;
        
        $('.action-ticket-details').on('click', goToTicketDetails);
        $('.ticket-info-ctn .action').on('click', openActionPopup);
        $('.action-popup-close').on('click', closeActionPopup);
        $('html').on('click', closeAllActionPopups);
        $('.ticket-info-ctn .action-popup-item').on('click', changeTicketInfo);
        
    }
    
    function goToTicketDetails(e) {
        const targ = e.currentTarget;
        let param = targ.getAttribute('data-param').split('=');
        
        window.location.search = setQuery(param[0], param[1]);
    }
    
    function openActionPopup(e) {
        e.stopPropagation();
        const btn = e.currentTarget;
        const popup = $(btn).parent().find('.action-popup');
        
        if (popup.hasClass('open')) {
            popup.removeClass('open');
        } else {
            $('.action-popup.open').removeClass('open');
            popup.addClass('open');
        }
    }
    
    function closeActionPopup(e) {
        $(e.currentTarget).closest('.action-popup').removeClass('open');
    }
    
    function closeAllActionPopups(e) {
        if (!e || !$(e.target).closest('.action-ctn')[0]) {
            $('.action-popup.open').removeClass('open');
        }
    }
    
    function changeTicketInfo(e) {
        const el = e.currentTarget;
        const param = el.dataset.key + '=' + el.dataset.value;
        const id = $(el).closest('.ticket-info-ctn').attr('data-id');
        
        ajax(actionPath + '?ajax=true&id=' + id + '&' + param, (resp) => {
            if (resp.indexOf('success-' + id) > -1) {
                $(el).closest('.action-ctn').find('.action .text')
                    .text(el.dataset.label ? el.dataset.label : el.textContent)
                    .attr('data-id', el.dataset.value);
            }
        }, true);
        
        closeAllActionPopups();
    }
	
	$(window).ready(init);
	
})();